"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shippingEpics = exports.validateShippingEpic = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _invitationType = require("../gift/invitationType");

var _shipping = require("./shipping.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var prepareValidationData = function prepareValidationData(_ref) {
  var _ref$address = _ref.address,
      state = _ref$address.state,
      address = (0, _objectWithoutProperties2.default)(_ref$address, ["state"]);
  return {
    address: _objectSpread(_objectSpread({}, address), {}, {
      state
    })
  };
};

var validateShippingEpic = function validateShippingEpic(action$, state$, _ref2) {
  var apiService = _ref2.apiService;
  return action$.pipe((0, _utils.ofType)(_shipping.validateShipping.pending), (0, _operators.debounceTime)(300), (0, _operators.withLatestFrom)(state$), (0, _operators.switchMap)(function (_ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
        _ref4$0$payload = _ref4[0].payload,
        giftId = _ref4$0$payload.giftId,
        address = _ref4$0$payload.address;

    return apiService.post("/enterprise/gifts/".concat(giftId, "/validate-address"), {
      body: prepareValidationData({
        address
      })
    }, true).pipe((0, _operators.map)(function (_ref5) {
      var data = _ref5.data;
      return _shipping.validateShipping.fulfilled({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        address: data.address,
        verifiedAddress: data.address,
        isAddressVerified: data.isAddressChanged,
        isAddressChanged: data.isAddressChanged
      });
    }), (0, _operators.catchError)(function (_ref6) {
      var error = _ref6.error;
      return (0, _rxjs.of)((0, _invitationType.saveInvitationTypeFail)({
        contact_address: error.errors
      }), _shipping.validateShipping.rejected(error.errors));
    }));
  }));
};

exports.validateShippingEpic = validateShippingEpic;
var shippingEpics = [validateShippingEpic];
exports.shippingEpics = shippingEpics;